import * as React from 'react'
import { adminService } from '../../../../../services'
import { Card, Segment } from 'semantic-ui-react'

type IRevenuePageState = {
    todayRevenue: number,
    thisMonthRevenue: number,
    isLoading: boolean
}

export default class RevenuePage extends React.Component {
    state: IRevenuePageState = {
        todayRevenue: 0,
        thisMonthRevenue: 0,
        isLoading: true
    }

    componentDidMount(): void {
        adminService.getTodayRevenue().then(value => {
            this.setState({
                todayRevenue: value ? value : 0,
                isLoading: false
            })
        })
        adminService.getThisMonthRevenue().then(value => {
            this.setState({
                thisMonthRevenue: value ? value : 0,
                isLoading: false
            })
        })
    }

    render(): JSX.Element | false | null {
        const {todayRevenue, thisMonthRevenue, isLoading} = this.state
        return (
            <Segment loading={isLoading}>
                <Card>
                    <Card.Content header={'Doanh thu hôm nay'}/>
                    <Card.Content textAlign={'center'} description={todayRevenue.toLocaleString('vn') + 'đ'}/>
                </Card>
                <Card>
                    <Card.Content header={'Doanh thu tháng này'}/>
                    <Card.Content textAlign={'center'} description={thisMonthRevenue.toLocaleString('vn') + 'đ'}/>
                </Card>
            </Segment>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/RevenuePage.tsx